var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { Col, Container, Row } from "reactstrap";
import { HeroImageContainer, HeroBreadcrumbs, HeroTitle, HeroDescription, HeroSmallImageCol, HeroSmallImage, HeroTextCol, HeroButton, HeroSmallImageWrapper } from "./Hero.styled";
import { useLinkResolver } from "../../components";

var Hero = function Hero(_a) {
  var isImageFullSize = _a.isImageFullSize,
      breadcrumbs = _a.breadcrumbs,
      title = _a.title,
      description = _a.description,
      imageUrl = _a.imageUrl,
      button = _a.button,
      isLight = _a.isLight,
      mobileImageUrl = _a.mobileImageUrl,
      anchor = _a.anchor,
      props = __rest(_a, ["isImageFullSize", "breadcrumbs", "title", "description", "imageUrl", "button", "isLight", "mobileImageUrl", "anchor"]);

  var resolveAction = useLinkResolver().resolveAction;
  return React.createElement(HeroImageContainer, __assign({
    id: anchor,
    fluid: true,
    isImageFullSize: isImageFullSize,
    imageUrl: imageUrl,
    mobileImageUrl: mobileImageUrl
  }, props), React.createElement(Container, null, breadcrumbs && React.createElement(Row, null, React.createElement(Col, {
    xs: 12
  }, React.createElement(HeroBreadcrumbs, {
    items: breadcrumbs,
    isLight: isLight
  }))), React.createElement(Row, null, !isImageFullSize && React.createElement(HeroSmallImageCol, {
    xs: 12,
    md: {
      size: 4,
      offset: 1,
      order: 2
    }
  }, React.createElement(HeroSmallImageWrapper, null, React.createElement(HeroSmallImage, {
    style: {
      backgroundImage: !isImageFullSize ? "url(" + imageUrl + ")" : "none"
    }
  }))), React.createElement(HeroTextCol, {
    xs: 12,
    md: 7,
    isImageFullSize: isImageFullSize
  }, React.createElement(HeroTitle, {
    size: "medium",
    color: isLight ? "white" : "black",
    element: "h1",
    hasBreadcrumbs: !!breadcrumbs,
    isImageFullSize: isImageFullSize
  }, title), React.createElement(HeroDescription, {
    leading: "large",
    color: isLight ? "white" : "black",
    isImageFullSize: isImageFullSize
  }, description), button && React.createElement(HeroButton, {
    onClick: function onClick() {
      return resolveAction(button.link);
    },
    isFullWidth: true
  }, button.title)))));
};

export default Hero;